import { Button } from "../components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#F6F8F3" }}>
      <div className="max-w-3xl mx-auto px-8 py-16">
        <Button
          onClick={() => navigate("/")}
          data-testid="back-to-home-from-privacy"
          className="mb-8 rounded-full"
          style={{ backgroundColor: "#27A64C", color: "white" }}
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Atpakaļ uz sākumlapu
        </Button>

        <h1
          className="text-4xl md:text-5xl font-black tracking-tight mb-8"
          style={{ color: "#1A2118" }}
          data-testid="privacy-title"
        >
          Privātuma politika
        </h1>

        <div
          className="space-y-6 text-base leading-relaxed"
          style={{ color: "#1A2118" }}
          data-testid="privacy-content"
        >
          <section>
            <h2 className="text-2xl font-bold mb-3" style={{ color: "#1A2118" }}>
              1. Pārzinis
            </h2>
            <p>
              Personas datu pārzinis ir <strong>SIA "MFM Solutions"</strong>,
              reģ. Nr. 40203672460, juridiskā adrese: Vēju iela "Filipi",
              Iecava, Bauskas novads, LV-3913.
            </p>
            <p className="mt-2">
              Saziņai par datu apstrādi:{" "}
              <a
                href="mailto:info@noplauts.lv"
                className="underline font-semibold"
                style={{ color: "#27A64C" }}
              >
                info@noplauts.lv
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3" style={{ color: "#1A2118" }}>
              2. Kādus datus mēs ievācam
            </h2>
            <p>
              Lai sazinātos ar klientu par zāles pļaušanas pakalpojumiem,
              ievācam: vārdu, telefona numuru un adresi.
            </p>
            <p className="mt-2">
              Lai izrakstītu rēķinu, papildus ievācam: vārdu, uzvārdu, deklarēto
              adresi vai personas kodu.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3" style={{ color: "#1A2118" }}>
              3. Apstrādes mērķis un tiesiskais pamats
            </h2>
            <p>
              Mēs apstrādājam datus, lai sniegtu zāles pļaušanas pakalpojumus,
              sazinātos ar klientu un izrakstītu rēķinus.
            </p>
            <p className="mt-2">Tiesiskais pamats:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>
                <strong>Līguma izpilde</strong> (VDAR 6. panta 1. punkta b)
                apakšpunkts) — lai sniegtu pasūtīto pakalpojumu;
              </li>
              <li>
                <strong>Juridisks pienākums</strong> (VDAR 6. panta 1. punkta c)
                apakšpunkts) — lai izpildītu grāmatvedības un nodokļu prasības.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3" style={{ color: "#1A2118" }}>
              4. Cik ilgi mēs glabājam datus
            </h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>
                Saziņas dati (kontaktforma) — līdz <strong>1 gadam</strong> pēc
                pēdējās saziņas, ja nenoslēdzas pakalpojuma līgums;
              </li>
              <li>
                Rēķinu un grāmatvedības dati — <strong>5 gadi</strong> saskaņā
                ar likuma "Par grāmatvedību" prasībām.
              </li>
            </ul>
            <p className="mt-2">
              Pēc termiņa beigām dati tiek dzēsti vai anonimizēti.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3" style={{ color: "#1A2118" }}>
              5. Datu nodošana
            </h2>
            <p>
              Dati netiek nodoti trešajām personām un tiek izmantoti tikai
              pakalpojuma sniegšanai. Dati netiek nodoti ārpus Eiropas
              Ekonomiskās zonas (EEZ).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3" style={{ color: "#1A2118" }}>
              6. Jūsu tiesības
            </h2>
            <p>Saskaņā ar VDAR jums ir šādas tiesības:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>
                <strong>Piekļūt</strong> saviem personas datiem un saņemt to
                kopiju;
              </li>
              <li>
                <strong>Labot</strong> neprecīzus vai nepilnīgus datus;
              </li>
              <li>
                <strong>Dzēst</strong> savus datus ("tiesības tikt aizmirstam"),
                ja apstrāde vairs nav nepieciešama;
              </li>
              <li>
                <strong>Ierobežot</strong> datu apstrādi noteiktos gadījumos;
              </li>
              <li>
                <strong>Iebilst</strong> pret datu apstrādi;
              </li>
              <li>
                <strong>Pārnesamība</strong> — saņemt datus strukturētā,
                mašīnlasāmā formātā.
              </li>
            </ul>
            <p className="mt-3">
              Lai izmantotu savas tiesības, rakstiet uz{" "}
              <a
                href="mailto:info@noplauts.lv"
                className="underline font-semibold"
                style={{ color: "#27A64C" }}
              >
                info@noplauts.lv
              </a>
              . Atbildēsim ne vēlāk kā 30 dienu laikā.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3" style={{ color: "#1A2118" }}>
              7. Sūdzību iesniegšana
            </h2>
            <p>
              Ja uzskatāt, ka jūsu datu apstrāde notiek prettiesiski, jums ir
              tiesības iesniegt sūdzību <strong>Datu valsts inspekcijā</strong>:
            </p>
            <ul className="list-none mt-2 space-y-1">
              <li>Elijas iela 17, Rīga, LV-1050</li>
              <li>
                Tālrunis: <a href="tel:+37167223131" className="underline" style={{ color: "#27A64C" }}>+371 67223131</a>
              </li>
              <li>
                E-pasts:{" "}
                <a
                  href="mailto:pasts@dvi.gov.lv"
                  className="underline"
                  style={{ color: "#27A64C" }}
                >
                  pasts@dvi.gov.lv
                </a>
              </li>
              <li>
                Tīmekļa vietne:{" "}
                <a
                  href="https://www.dvi.gov.lv"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline"
                  style={{ color: "#27A64C" }}
                >
                  www.dvi.gov.lv
                </a>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3" style={{ color: "#1A2118" }}>
              8. Sīkdatnes
            </h2>
            <p>
              Mēs izmantojam tikai tehniski nepieciešamās sīkdatnes lapas
              darbībai (piem. autentifikācijai). Analītiskās vai mārketinga
              sīkdatnes netiek izmantotas.
            </p>
          </section>

          <div
            className="pt-8 mt-8 border-t text-sm"
            style={{ borderColor: "rgba(26, 33, 24, 0.08)", color: "#475545" }}
          >
            <p>
              Šī privātuma politika ir spēkā no 2026. gada 5. jūnija. Politika
              var tikt atjaunināta; aktuālā versija vienmēr pieejama šajā lapā.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
